<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
<!--          <a-col :md="6" :sm="8">-->
<!--            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标题">-->
<!--              <a-input placeholder="请输入标题" v-model="queryParam.title"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日程类型">
              <j-dict-select-tag
                placeholder="请选择类型"
                dictCode="plan_type"
                v-model="queryParam.type"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>

          <!-- <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="提醒类型">
              <j-dict-select-tag
                placeholder="请选择提醒类型"
                dictCode="remind_type"
                v-model="queryParam.remindType"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col> -->

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开始时间">
              <a-range-picker
                format="YYYY-MM-DD"
                v-model="dates.startTime"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateStartTime"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结束时间">
              <a-range-picker
                format="YYYY-MM-DD"
                v-model="dates.endTime"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateEndTime"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设施类型">
              <j-dict-select-tag
                placeholder="请选择设施类型"
                dictCode="operation_type"
                v-model="queryParam.operationType"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="提醒类型">
              <j-dict-select-tag
                placeholder="请选择提醒类型"
                dictCode="reminder_time"
                v-model="queryParam.reminders"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col> -->
          <template v-if="toggleSearchStatus">

            <!-- <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="重复提醒">
                <j-dict-select-tag
                  placeholder="请选择重复提醒"
                  dictCode="plan_remind"
                  v-model="queryParam.remind"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col> -->

<!--            <a-col :md="6" :sm="8">-->
<!--              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="紧急程度">-->
<!--                <j-dict-select-tag-->
<!--                  placeholder="请选择紧急程度"-->
<!--                  dictCode="urgent_level"-->
<!--                  v-model="queryParam.urgentLevel"-->
<!--                ></j-dict-select-tag>-->
<!--              </a-form-item>-->
<!--            </a-col>-->

            <!-- <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="参与人">
                <a-input placeholder="请输入参与人" v-model="queryParam.userId" />
              </a-form-item>
            </a-col> -->



            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                <j-dict-select-tag
                  placeholder="请选择状态"
                  dictCode="plan_status"
                  v-model="queryParam.status"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <work-plan-query-toggle v-if="isAdmin" :checked="queryAll" @change="changeQueryAll" />
      <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
      <a-button @click="searchReset" icon="reload">重置</a-button>
      <a-button type="dashed" @click="handleToggleSearch" style="margin-left: 15px; margin-right: 50px"
      >{{ toggleSearchStatus ? '收起' : '展开' }}
        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"
        />
      </a-button>
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!--<a-button icon="download" @click="handleExportXls()">导出</a-button>
            <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="handleImportFile" @change="handleImportExcel">
                <a-button  type="danger" icon="import" ghost>导入</a-button>
            </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="status" slot-scope="text,record">
          <span :style="`color:${record.status==2?'green':'red'}`">{{record.status_dictText}}</span>
        </span>
        <span slot="nextStatus" slot-scope="text,record">
          <span :style="`color:${text?'':'red'}`">{{text?text:'未发起审批'}}</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a
            @click="handleDetail(record)"
            :style="canProcess(record) ? 'font-weight: 600; color: #1890ff;' : ''"
          >
            {{ canProcess(record) ? '去处理' : '详情' }}
          </a>
          <template v-if="record.type !== '10'">
            <a-divider type="vertical"/>
            <a @click="handleEdit(record)" v-if="canEdit(record)">编辑</a>
            <span v-else style="color: #bbb; cursor: not-allowed;" :title="getEditDisabledTitle(record)">编辑</span>
            <template v-if="getAuth(record.createBy)">
              <a-divider type="vertical"/>
              <a-popconfirm v-if="canDelete(record)" title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
              <span v-else style="color: #bbb; cursor: not-allowed;" title="已有项目执行完成，不可删除">删除</span>
            </template>
          </template>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <work-plan-modal ref="modalForm" :pagePath="pagePath" @ok="modalFormOk"></work-plan-modal>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WorkPlanQueryMixin from './WorkPlanQueryMixin'
  import WorkPlanQueryToggle from './modules/WorkPlanQueryToggle.vue'
  import WorkPlanModal from './modules/WorkPlanModalDt.vue'

  export default {
    name: 'WorkPlanList',
    mixins: [JeecgListMixin, WorkPlanQueryMixin],
    components: {
      WorkPlanQueryToggle,
      WorkPlanModal
    },
    data() {
      return {
        pagePath: '/om/work/plan',
        pageTitle: '工作计划',
        isorter: {
          column: 'create_time',
          order: 'desc'
        },
        projectCode:'',
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function(t, r, index) {
              return parseInt(index) + 1
            }
          },
          // {
          //   dataIndex: 'title',
          //   colName: 'title',
          //   title: '标题',
          //   align: 'center',
          //   sorter: true
          // },
          {
            dataIndex: 'siteName',
            colName: 'siteName',
            title: '站点',
            align: 'center',
            sorter: true
          },
          {
            dataIndex: 'startTime',
            colName: 'start_time',
            title: '开始时间',
            align: 'center',
            sorter: true
          },
          {
            dataIndex: 'endTime',
            colName: 'end_time',
            title: '结束时间',
            align: 'center',
            sorter: true
          },
          // {
          //   dataIndex: 'type_dictText',
          //   colName: 'type',
          //   title: '计划类型',
          //   align: 'center'
          // },
          {
            dataIndex: 'operationType_dictText',
            colName: 'operationType',
            title: '设施类型',
            align: 'center'
          },
          // {
          //   dataIndex: 'allDay_dictText',
          //   colName: 'all_day',
          //   title: '是否全天',
          //   align: 'center',
          // },
          // {
          //   dataIndex: 'urgentLevel_dictText',
          //   colName: 'urgent_level',
          //   title: '紧急程度',
          //   align: 'center'
          // },
          // {
          //   dataIndex: 'remindType_dictText',
          //   colName: 'remind_type',
          //   title: '提醒类型',
          //   align: 'center',
          // },
          {
            dataIndex: 'createBy_userName',
            colName: 'create_by',
            title: '创建用户',
            align: 'center'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 120,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    created() {
      if(window.localStorage.getItem('projectCode')){
        this.projectCode = window.localStorage.getItem('projectCode')
      }
      if(this.projectCode=='meitang'){
        this.columns.splice(7,1)
      }
    },
    computed: {},
    methods: {
      onDateReminderTime: function(value, dateArray) {
        this.queryParam.reminderTimeStart = dateArray[0]
        this.queryParam.reminderTimeEnd = dateArray[1]
      },
      onDateStartTime: function(value, dateArray) {
        this.queryParam.startTimeStart = dateArray[0]
        this.queryParam.startTimeEnd = dateArray[1]
      },
      onDateEndTime: function(value, dateArray) {
        this.queryParam.endTimeStart = dateArray[0]
        this.queryParam.endTimeEnd = dateArray[1]
      },
      canProcess(record) {
        if (!record || record.status == 2) return false
        const user = this.$store.getters.userInfo
        if (!user || !user.id) return false
        if (record.createBy == user.id) return true
        if (record.executorIds && Array.isArray(record.executorIds)) {
          if (record.executorIds.includes(user.id) || record.executorIds.includes(Number(user.id))) return true
        }
        if (record.executorNames && user.realname) {
          if (record.executorNames.split(',').includes(user.realname)) return true
        }
        return false
      },
      handleDetail(record) {
        const isProcess = this.canProcess(record)
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = isProcess ? `处理日程：${record.title || ''}` : `日程详情：${record.title || ''}`
        this.$refs.modalForm.disableSubmit = true
      },
      canEdit(record) {
        if (!record || record.status == 2 || record.status === '2') return false
        if (record.workPlanDetailList && Array.isArray(record.workPlanDetailList)) {
          return !record.workPlanDetailList.some(d => d.status == 2 || d.status === '2')
        }
        return true
      },
      canDelete(record) {
        if (!record || record.status == 2 || record.status === '2') return false
        if (record.workPlanDetailList && Array.isArray(record.workPlanDetailList)) {
          return !record.workPlanDetailList.some(d => d.status == 2 || d.status === '2')
        }
        return true
      },
      getEditDisabledTitle(record) {
        if (record && (record.status == 2 || record.status === '2')) {
          return '已完成日程不可编辑'
        }
        return '已有项目执行完成，不可编辑'
      },
      handleEdit(record) {
        if (!this.canEdit(record)) {
          this.$message.warning(this.getEditDisabledTitle(record))
          return
        }
        this.$refs.modalForm.title = '编辑：' + this.pageTitle
        this.$refs.modalForm.disableSubmit = false
        this.$refs.modalForm.showTab = true
        this.$refs.modalForm.showContact = true
        this.$refs.modalForm.edit(record)
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';

  .table-operator .plan-query-toggle {
    margin-right: 12px;
  }
</style>
